import {
  IAssociation,
  IAssociationConfig,
  IAssociationResource,
} from "../../types/association/Association";
import AssociationsApi from "../api/associationsApi";
import * as types from "./actionTypes";

function getManageableAssociationsStart() {
  return { type: types.ASSOCIATIONS_GET_MANAGEABLE_STARTED };
}

function getManageableAssociationsRejected(message: string) {
  return { type: types.ASSOCIATIONS_GET_MANAGEABLE_REJECTED, message };
}

function getManageableAssociationsFulfilled(associations: IAssociation[]) {
  return {
    type: types.ASSOCIATIONS_GET_MANAGEABLE_FULFILLED,
    payload: associations,
  };
}

function getMyAssociationsFulfilled(associations: IAssociation[]) {
  return {
    type: types.ASSOCIATIONS_GET_MY_FULFILLED,
    payload: associations,
  };
}

function getMyAssociationResourcesFulfilled(
  associationResources: IAssociationResource[],
) {
  return {
    type: types.ASSOCIATIONS_GET_RESOURCES_FULFILLED,
    payload: associationResources,
  };
}

export function getManageableAssociations(effectiveDate?: Date | string): (
  dispatch: Function,
) => Promise<IAssociation[]> {
  return (dispatch) => {
    dispatch(getManageableAssociationsStart());
    return AssociationsApi.getAdminAssociations(effectiveDate)
      .then((assns) => {
        dispatch(getManageableAssociationsFulfilled(assns));
        return assns;
      })
      .catch((er) => {
        dispatch(getManageableAssociationsRejected(er.message));
        throw er;
      });
  };
}

export function getMyAssociations(effectiveDate?: Date | string): (
  dispatch: Function,
) => Promise<IAssociation[]> {
  return (dispatch) =>
    AssociationsApi.getMyAssociations(effectiveDate).then((associations) => {
      dispatch(getMyAssociationsFulfilled(associations));
      return associations;
    });
}

export function getMyAssociationResources(): (
  dispatch: Function,
) => Promise<IAssociationResource[]> {
  return (dispatch) =>
    AssociationsApi.getMyAssociationResources().then((resources) => {
      dispatch(getMyAssociationResourcesFulfilled(resources));
      return resources;
    });
}

function updateAssociationConfigStart() {
  return { type: types.ASSOCIATIONS_UPDATE_CONFIG_STARTED };
}

function updateAssociationConfigRejected(message: string) {
  return { type: types.ASSOCIATIONS_UPDATE_CONFIG_REJECTED, message };
}

function updateAssociationConfigFulfilled(association: IAssociation) {
  return {
    type: types.ASSOCIATIONS_UPDATE_CONFIG_FULFILLED,
    payload: association,
  };
}

export function updateAssociationConfig(
  associationId: string,
  configUpdates: Partial<IAssociationConfig>
): (dispatch: Function) => Promise<IAssociation> {
  return (dispatch) => {
    dispatch(updateAssociationConfigStart());
    return AssociationsApi.updateAssociationConfig(associationId, configUpdates)
      .then((association) => {
        dispatch(updateAssociationConfigFulfilled(association));
        return association;
      })
      .catch((er) => {
        dispatch(updateAssociationConfigRejected(er.message));
        throw er;
      });
  };
}
